<template>
    <v-container>
        <v-card class="elevation-12" width='100%'>
            <v-toolbar color="primary" dark>
                <v-card-title>
                    <v-icon color="white">mdi-auto-fix</v-icon>&nbsp; Carga de datos a smartchronos
                </v-card-title>
            </v-toolbar> 
            <v-card-text>
                <smartchronosForm/>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue'
    import smartchronosForm from './smartchronosForm.vue';
    export default Vue.extend({
        name: 'formsmartchronos',
        components:{
            smartchronosForm
        }
    })
</script>